import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AlertController } from '@ionic/angular';

export async function apresentarAvisoCalculadoraTev(alertas: AlertController): Promise<void> {
  const logado = !!localStorage.getItem('userData');
  const alerta = await alertas.create({
    header: 'Atenção',
    subHeader: 'Conteúdo exclusivo',
    message: logado
      ? 'A calculadora CNE TEV é exclusiva para associados ativos. Associe-se para usar o escore.'
      : 'A calculadora CNE TEV é exclusiva para associados ativos. Entre com o login de associado ou associe-se para usar o escore.',
    backdropDismiss: false,
    buttons: logado
      ? [
          { text: 'Fechar', role: 'cancel' },
          {
            text: 'Associe-se',
            handler: () => {
              window.open('https://www.febrasgo.org.br/lp/anuidades/', '_blank', 'noopener');
            }
          }
        ]
      : [
          { text: 'Realizar Login', role: 'cancel' },
          {
            text: 'Associe-se',
            handler: () => {
              window.open('https://www.febrasgo.org.br/lp/anuidades/', '_blank', 'noopener');
            }
          }
        ]
  });
  await alerta.present();
  await alerta.onDidDismiss();
}

export function associadoDaSessao(): number {
  try {
    const cru = localStorage.getItem('userData');
    const dados = cru ? JSON.parse(cru) : null;
    const id = dados && dados.associated_id ? Number(dados.associated_id) : 0;
    return id > 0 ? id : 0;
  } catch (e) {
    return 0;
  }
}

@Injectable({ providedIn: 'root' })
export class CalculadoraTevGuard implements CanActivate {
  constructor(private router: Router, private alertController: AlertController) {}

  async canActivate(): Promise<boolean> {
    if (associadoDaSessao() > 0) {
      return true;
    }

    const logado = !!localStorage.getItem('userData');
    await apresentarAvisoCalculadoraTev(this.alertController);
    this.router.navigateByUrl(logado ? '/calculadoras' : '/login');
    return false;
  }
}
